'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('./colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Stepper = function (_Component) {
  _inherits(Stepper, _Component);

  function Stepper() {
    _classCallCheck(this, Stepper);

    return _possibleConstructorReturn(this, (Stepper.__proto__ || Object.getPrototypeOf(Stepper)).apply(this, arguments));
  }

  _createClass(Stepper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          activeStep = _props.activeStep,
          bsStyle = _props.bsStyle,
          small = _props.small,
          color = _props.color,
          partial = _props.partial;

      var connector = _react2.default.createElement('div', {
        style: {
          flex: '1 1 auto',
          borderTop: '1px solid ' + colors.alloy,
          marginTop: '6px'
        }
      });

      var activeColor = color || colors[bsStyle].base; // Extended from https://github.com/callemall/material-ui/blob/master/src/Stepper/Stepper.js

      var activeIndex = activeStep;

      if (typeof activeStep === 'string') {
        // find the active step index if the user passed a string
        activeIndex = _react.Children.toArray(children).findIndex(function (step) {
          return step.props.name === activeStep;
        });
      }

      var steps = _react.Children.map(children, function (step, index) {
        var controlProps = {
          index: index,
          activeColor: activeColor,
          small: small
        };

        if (activeIndex === index) {
          controlProps.active = true;
          controlProps.partial = partial;
        } else if (activeIndex > index) {
          controlProps.completed = true;
        } else if (activeIndex < index) {// do we want to add anything here?
        }

        return [index > 0 && connector, _react2.default.cloneElement(step, _extends({}, controlProps, step.props))];
      });

      return _react2.default.createElement('div', {
        className: 'stepper',
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '14px 0 0'
        }
      }, steps);
    }
  }]);

  return Stepper;
}(_react.Component);

exports.default = Stepper;
Stepper.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.node),
  activeStep: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  partial: _propTypes2.default.bool,
  bsStyle: _propTypes2.default.string,
  color: _propTypes2.default.string,
  small: _propTypes2.default.bool
};
Stepper.defaultProps = {
  bsStyle: 'success',
  small: false
};